import orderBy from 'lodash/orderBy';
import { ARMToday, ARMTodayTask } from '../../../types';

export const orderByMonthAndDay = (params: {
  data: ARMTodayTask[];
}): ARMTodayTask[] => {
  // Create an array that can be ordered by milestone month and day
  const milestoneData: {
    task: ARMTodayTask;
    milestoneMonth: number;
    milestoneDay: number;
  }[] = [];

  const milestones = orderBy(params.data, 'MilestoneDate', 'desc');

  milestones.forEach((task) => {
    // "1988-08-29 00:00:00.000" -> "1988-08-29"
    const MilestoneDate = task.MilestoneDate?.split(' ')[0];

    if (MilestoneDate) {
      const newMilestoneDate = new Date(MilestoneDate + 'T00:00');
      milestoneData.push({
        task,
        milestoneMonth: newMilestoneDate.getMonth(),
        milestoneDay: newMilestoneDate.getDate(),
      });
    }
  });

  // Order the array by birth month an day
  const orderedMilestoneData = orderBy(milestoneData, [
    'milestoneMonth',
    'milestoneDay',
  ]);

  // Return the array of tasks passed into the function
  // Now ordered by milestone month and day
  const milestonesToReturn: ARMTodayTask[] = [];
  orderedMilestoneData.forEach((item) => {
    milestonesToReturn.push(item.task);
  });

  return milestonesToReturn;
};

export interface ARMTodayTotals {
  todayCount: number;
  FirstGLOBonusCount: number;
  FirstOverrideCount: number;
  FirstFastractedAgentCount: number;
  FirstARCDepositCount: number;
  DOBCount: number;
}

export const getARMTodayTotals = (params: {
  data: ARMToday;
  showCompleted: boolean;
}): ARMTodayTotals => {
  const totals: ARMTodayTotals = {
    todayCount: 0,
    FirstGLOBonusCount: 0,
    FirstOverrideCount: 0,
    FirstFastractedAgentCount: 0,
    FirstARCDepositCount: 0,
    DOBCount: 0,
  };

  if (params.showCompleted) {
    // All tasks

    // First GLO Bonus
    totals.FirstGLOBonusCount = params.data.FirstGLOBonus?.length || 0;

    // First Override
    totals.FirstOverrideCount = params.data.FirstOverride?.length || 0;

    // First Fastracted Agent
    totals.FirstFastractedAgentCount =
      params.data.FirstFastractedAgent?.length || 0;

    // First ARC Deposit
    totals.FirstARCDepositCount = params.data.FirstARCDeposit?.length || 0;

    // DOB
    totals.DOBCount = params.data.DOB?.length || 0;
  } else {
    // Uncompleted tasks

    // First GLO Bonus
    totals.FirstGLOBonusCount =
      params.data.FirstGLOBonus?.filter((i) => i.Completed === '0').length || 0;

    // First Override
    totals.FirstOverrideCount =
      params.data.FirstOverride?.filter((i) => i.Completed === '0').length || 0;

    // First Fastracted Agent
    totals.FirstFastractedAgentCount =
      params.data.FirstFastractedAgent?.filter((i) => i.Completed === '0')
        .length || 0;

    // First ARC Deposit
    totals.FirstARCDepositCount =
      params.data.FirstARCDeposit?.filter((i) => i.Completed === '0').length ||
      0;

    // DOB
    totals.DOBCount =
      params.data.DOB?.filter((i) => i.Completed === '0').length || 0;
  }

  // The todayCount will be shown on the button that
  // is used to select the Today tab of the CRM
  totals.todayCount =
    totals.FirstGLOBonusCount +
    totals.FirstOverrideCount +
    totals.FirstFastractedAgentCount +
    totals.FirstARCDepositCount +
    totals.DOBCount;

  return totals;
};
